import script from "./HeaderContacts.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderContacts.vue?vue&type=script&setup=true&lang=js"

import "./HeaderContacts.vue?vue&type=style&index=0&id=3ded5894&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ded5894"]])

export default __exports__